




    import 'reflect-metadata';
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class Promo extends Vue {
        @Prop() public readonly place!: string;
    }
